import methodNone from './none';
// import methodVisa from './visa';
import methodPaypal from './paypal';

const methods = {};
methods[methodNone.id] = methodNone;
// methods[methodVisa.id] = methodVisa;
methods[methodPaypal.id] = methodPaypal;

const milliseconds = Date.now();
const seconds = Math.floor(milliseconds / 1000);
const days = Math.floor(seconds / (24 * 3600));
const month = Math.floor(days / 30);

export { month as payPeriod };

export default methods;
